import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconPage = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsx(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    "data-mntl-flip-svg": "true"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M1 6.077h22M4.143 10.872h6.286m-6.286 3.384h6.286m-6.286 3.385h4.191M2.571 23H21.43c.867 0 1.571-.758 1.571-1.692V2.692C23 1.758 22.296 1 21.429 1H2.57C1.704 1 1 1.758 1 2.692v18.616C1 22.242 1.704 23 2.571 23zm11.786-5.359h4.714c.434 0 .786-.379.786-.846v-5.077c0-.467-.352-.846-.786-.846h-4.714c-.434 0-.786.379-.786.846v5.077c0 .467.352.846.786.846z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
});
IconPage.displayName = "IconPage";

export { IconPage };
